module.exports = __webpack_public_path__ + "img/Inform Graphic 1.e60f891c.png";